import React, { useEffect } from "react";
import { api } from "../config/api";

function Admin() {
  useEffect(() => {
    const newTab = window.open(api("/admin"), "_self");

    if (!newTab) {
      alert("Popup blocked! Please allow popups for this site.");
    }
  }, []);

  return (
    <div style={styles.container}>
      <div className="loader"></div>
      <p style={styles.text}>Opening Admin Panel...</p>

      <style>
        {`
          .loader {
            border: 6px solid rgba(255, 255, 255, 0.3);
            border-top: 6px solid #fff;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
            margin-bottom: 20px;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "linear-gradient(135deg, #667eea, #764ba2)",
    color: "#fff",
    fontFamily: "Arial, sans-serif",
  },
  text: {
    marginTop: "10px",
    fontSize: "18px",
    fontWeight: "500",
  },
};

export default Admin;
